import { render, staticRenderFns } from "./CourtFloor.vue?vue&type=template&id=5543841a&scoped=true&"
import script from "./CourtFloor.vue?vue&type=script&lang=js&"
export * from "./CourtFloor.vue?vue&type=script&lang=js&"
import style0 from "./CourtFloor.vue?vue&type=style&index=0&id=5543841a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5543841a",
  null
  
)

export default component.exports